export default {
  ekaterinburg: [
    {
      title: 'Полное наименование предприятия',
      text: 'Общество с ограниченной ответственностью «Очень Интересно»',
    },
    {
      title: 'ИНН',
      text: '6670121971',
    },
    {
      title: 'КПП',
      text: '667801001',
    },
    {
      title: 'ОГРН',
      text: '1069670120178',
    },
    {
      title: 'ОКВЭД',
      text: '62.01',
    },
    {
      title: 'Доп. ОКВЭД',
      text: '62.02, 63.11',
    },
    {
      title: 'Юридический адрес',
      text: '620027, г. Екатеринбург, пер. Красный, д. 5, к. 1, офис 210',
    },
    {
      title: 'Фактический адрес',
      text: '620027, г. Екатеринбург, пер. Красный, д. 5, к. 1, офис 210',
    },
    {
      title: 'Электронная почта',
      text: 'office.e@interesnee.ru',
    },
    {
      title: 'Директор',
      text: 'Янковенко Владимир Викторович',
    },
  ],
  krasnoyarsk: [
    {
      title: 'Полное наименование предприятия',
      text: 'Общество с ограниченной ответственностью «Очень Интересно»',
    },
    {
      title: 'ИНН',
      text: '2460227734',
    },
    {
      title: 'КПП',
      text: '246001001',
    },
    {
      title: 'ОГРН',
      text: '1112468002261',
    },
    {
      title: 'ОКВЭД',
      text: '62.01',
    },
    {
      title: 'Доп. ОКВЭД',
      text: '62.09, 63.11',
    },
    {
      title: 'Юридический адрес',
      text: '660041, Красноярск, ул. Курчатова 1А - 64',
    },
    {
      title: 'Фактический адрес',
      text: '660017, Красноярск, ул. Красной Армии 10, стр 5',
    },
    {
      title: 'Электронная почта',
      text: 'office.k@interesnee.ru',
    },
    {
      title: 'Директор',
      text: 'Бидус Борис Михайлович',
    },
  ],
  sochi: [
    {
      title: 'Полное наименование предприятия',
      text:
        'Филиал «Сочинский» Общества с ограниченной ответственностью «Очень Интересно»',
    },
    {
      title: 'ИНН',
      text: '6670121971',
    },
    {
      title: 'КПП',
      text: '236643001',
    },
    {
      title: 'ОГРН',
      text: '1069670120178',
    },
    {
      title: 'ОКВЭД',
      text: '62.01',
    },
    {
      title: 'Доп. ОКВЭД',
      text: '62.02, 63.11',
    },
    {
      title: 'Юридический адрес',
      text: '620027, г. Екатеринбург, пер. Красный, д. 5, к. 1, офис 210',
    },
    {
      title: 'Фактический адрес',
      text: '354057, Краснодарский край, г. Сочи, ул. Невская, д. 23, офис 14',
    },
    {
      title: 'Электронная почта',
      text: 'office.s@interesnee.ru',
    },
    {
      title: 'Директор',
      text: 'Васильев Константин Олегович',
    },
  ],
};

export const card = {
  title: 'Карточка предприятия',
};

export const services = {
  title: 'Услуги',
  description: 'Компания оказывает комплексные услуги в сфере информационных технологий, включая <b>разработку, доработку и сопровождение программного обеспечения</b>, проектирование и внедрение программных решений, <b>с использованием вычислительной техники и информационных технологий</b>.<br><br>Мы разрабатываем веб-, XR- и мобильные приложения, корпоративные комплексные системы, интегрируем с внешними сервисами, обеспечиваем техническую поддержку, тестирование и оптимизацию ПО, предоставляем ИТ-консалтинг, автоматизируем бизнес-процессы и выполняем работы по размещению и сопровождению информационных ресурсов, помогая бизнесу эффективно использовать цифровые технологии для роста и масштабирования.',
};

export const servicesCost = {
  title: 'Стоимость услуг',
  description: 'Стоимость работ определяется в индивидуальном порядке на основании утверждённого технического задания с учётом средней стоимости одного часа работ в размере 12 000 (двенадцать тысяч) рублей и минимального объёма разработки, составляющего 2 000 (две тысячи) часов.<br><br>Заявку на оказание услуг направлять на электронный адрес офиса компании.',
};



// WEBPACK FOOTER //
// ./src/data/mockCompaniesInfo.js